<template>
  <div
    :class="[
      'modal-mask',
      { 'sticky-bottom show': animationStyle == 'slide-up-stick-bottom' },
      modalClass,
    ]"
    :style="{
      zIndex: zIndex,
    }"
    @click.self="closeModal($event)"
    @click.stop
    id="generic-modal-mask-id"
  >
    <div
      :class="['modal-container animated', mcClass]"
      :style="{
        width: width,
        maxHeight: maxHeight,
        height: height,
        maxWidth: width,
        padding: padding,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        bottom: bottom,
        background: background,
        backgroundRepeat: backgroundRepeat,
        backgroundSize: backgroundSize,
        borderRadius: borderRadius,
        left: left,
        overflow: overflow,
      }"
    >
      <div :class="[!!overflowNotNeeded ? 'overflow-hide' : '']">
        <div
          class="modal-header"
          :style="{
            position: headerPosition,
            zIndex: headerZIndex,
            top: headerTop,
            background: headerBackground,
            height: headerHeight,
            width: headerWidth || '100vw',
          }"
        >
          <slot name="header">
            <!-- <h2 class="modal-default-button" @click="closeModal()">XX</h2> -->
          </slot>
        </div>
        <div
          class="modal-body"
          :class="{ 'modal-content-scroll': contentScroll }"
          :style="[
            contentScroll && { 'max-height': height },
            { background: backgroundBody },
          ]"
        >
          <slot name="body"></slot>
        </div>

        <div class="modal-footer" :style="{ background: backgroundFooter }">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericModal",
  props: [
    "width",
    "height",
    "animationStyle",
    "modalClass",
    "contentScroll",
    "padding",
    "zIndex",
    "overflowNotNeeded",
    "background",
    "backgroundRepeat",
    "backgroundSize",
    "paddingTop",
    "bottom",
    "paddingBottom",
    "borderRadius",
    "maxHeight",
    "headerPosition",
    "headerZIndex",
    "headerTop",
    "headerBackground",
    "headerWidth",
    "left",
    "overflow",
    "mcClass",
    "headerHeight",
    "backgroundBody",
    "backgroundFooter",
    "genericModalSource",
  ],
  data() {
    return {};
  },
  mounted() {
    if (
      this.genericModalSource === "searchModal" &&
      document.getElementById("searchQueryInputModal")?.value !== undefined
    ) {
      document.getElementById("searchQueryInputModal").focus();
    }
  },
  methods: {
    closeModal(e) {
      e.stopPropagation();
      if (!this.$store.state.ProductItems.showSearchModal) {
        document.body.classList.remove("body-stop-scroll-mobile");
      }
      this.$emit("close", e);
    },
  },
};
</script>

<style scoped></style>
